import React from "react";
import styles from "./PayWithButton.module.css";
import { Button } from "../Button";
import { ReactComponent as KlashaWhiteLogo } from "../../../assets/klasha_logo.svg";
import { ButtonLoader } from "../Loader";

export const PayWithButton = ({
  isLoading,
  isDisabled,
}: {
  isLoading?: boolean;
  isDisabled?: boolean;
}) => {
  return (
    <Button
      type="submit"
      text={
        isLoading ? (
          <ButtonLoader />
        ) : (
          <div className={styles.text}>
            <p className={styles.btntxt}>Pay with</p> <KlashaWhiteLogo />
          </div>
        )
      }
      buttonStyle="primary"
      disabled={isDisabled}
      isButtonLoading={isLoading}
    />
  );
};
